import React from 'react'
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

function About() {
    return (
        <Container maxWidth="md" sx={{ py: 3 }}>
            <h2>We Build. We Own. We Deliver :</h2>

            <Typography style={{ marginTop: 16 }}>
                We are a full-cycle software development company that builds and delivers all types of digital products — web applications, mobile applications, and desktop applications. We provide end-to-end solutions, covering everything from requirement analysis and UI/UX design to development, testing, deployment, and ongoing support.
            </Typography>

            <h3>What We Do</h3>
            <Typography style={{ marginTop: 8 }}>
                <strong>Custom Software Development</strong> — Tailor-made web, mobile, and desktop applications built to fit your exact business needs.
            </Typography>
            <Typography style={{ marginTop: 8 }}>
                <strong>Product Consulting</strong> — Expert guidance on technology strategy, architecture decisions, and product roadmap planning to help you build the right thing the right way.
            </Typography>
            <Typography style={{ marginTop: 8 }}>
                <strong>IT Outsourcing</strong> — Extend your team with skilled engineers who integrate seamlessly into your workflows and deliver consistent results.
            </Typography>
            <Typography style={{ marginTop: 8 }}>
                <strong>End-to-End Delivery</strong> — From idea to production, we own the entire development lifecycle so you don't have to manage multiple vendors.
            </Typography>

            <h3>Our Own Products</h3>
            <Typography style={{ marginTop: 8 }}>
                Unlike pure service agencies, we also own and operate our own digital platforms. Our real estate platform enables zero-brokerage buying, selling, and renting of property. Our hotel booking system is currently in development. Both products are built entirely in-house — fully supported, customizable, and scalable for business clients.
            </Typography>
        </Container>
   )
}

export default About